import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-table',
  templateUrl: './button-table.component.html',
  styleUrls: ['./button-table.component.scss']
})
export class ButtonTableComponent implements OnInit {

  @Input() public type: string = "";
  @Input() public style: string = "";
  @Input() public loading: string = "";

  constructor() { }

  ngOnInit() {
  }

}
